/*
  nc-spec-fold – rækkerne i "Tekniske specifikationer" (snippets/nc-spec-rows) står på én linje
  med "…" og folder ud ved klik (<details class="nc-spec-fold">). Kan værdien være på én linje,
  får rækken .nc-spec-fold--fit: ingen pil, intet klik. Indlæses kun på produktsider.
*/
(() => {
  function check() {
    document.querySelectorAll('.nc-spec-fold:not([open])').forEach((el) => {
      const text = el.querySelector('.nc-spec-fold__text');
      // Skjult akkordeon (bredde 0) siger intet om pladsen: behold seneste måling.
      if (!text || text.clientWidth === 0) return;
      el.classList.remove('nc-spec-fold--fit');
      if (text.scrollWidth <= text.clientWidth + 1) el.classList.add('nc-spec-fold--fit');
    });
  }

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.nc-spec-fold--fit > summary');
    if (summary) event.preventDefault();
  });

  // Akkordeonen kan være lukket ved indlæsning (bredde 0) – tjek igen når den bliver synlig.
  const ro = new ResizeObserver(check);
  const start = () => document.querySelectorAll('.nc-spec-fold').forEach((el) => ro.observe(el));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // Webfonten ændrer tekstbredden uden at ændre rækkens størrelse – mål igen, når den er indlæst.
  window.addEventListener('load', check);
  // Variantskift kan ændre værdien (fx katalysator pr. variant).
  document.addEventListener('product:variant-change', () => requestAnimationFrame(check));
  if (document.fonts) document.fonts.ready.then(check);
})();
